module.exports = __webpack_public_path__ + "137340454f5a881500934a9560c8a577.png";